import { render, staticRenderFns } from "./tax_invoice.vue?vue&type=template&id=52e42ce7&"
import script from "./tax_invoice.vue?vue&type=script&lang=js&"
export * from "./tax_invoice.vue?vue&type=script&lang=js&"
import style0 from "./tax_invoice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports